function floatToString(e, t) {
  var n = e.toFixed(t).toString();
  return n.match(/^\.\d+/) ? "0" + n : n
}

function attributeToString(e) {
  return "string" != typeof e && (e += "", "undefined" === e && (e = "")), jQuery.trim(e)
}
"undefined" == typeof window.Shopify && (window.Shopify = {}), Shopify.KT_money_format = "$", Shopify.KT_onError = function(e, t) {
  var n = eval("(" + e.responseText + ")");
  n.message ? alert(n.message + "(" + n.status + "): " + n.description) : alert("Error : " + Shopify.KT_fullMessagesFromErrors(n).join("; ") + ".")
},
Shopify.KT_fullMessagesFromErrors = function(e) {
  var t = [];
  return jQuery.each(e, function(e, n) {
    jQuery.each(n, function(n, r) {
      t.push(e + " " + r)
    })
  }), t
},
Shopify.KT_onCartUpdate = function(e,remove) {
  // alert("There are now " + e.item_count + " items in the cart.");
  Shopify.KT_onCartUpdate_(e,remove);
},
Shopify.KT_onCartShippingRatesUpdate = function(e, t) {
  var n = "";
  t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country;
},
Shopify.KT_onItemAdded = function(e) {
  // alert(e.title + " was added to your shopping cart.");
  Shopify.KT_getCart();
},
Shopify.KT_onProduct = function(e) {
  alert("Received everything we ever wanted to know about " + e.title)
},
Shopify.KT_formatMoney = function(e, t) {
  function n(e, t) {
    return "undefined" == typeof e ? t : e
  }

  function r(e, t, r, i) {
    if (t = n(t, 2), r = n(r, ","), i = n(i, "."), isNaN(e) || null == e) return 0;
    e = (e / 100).toFixed(t);
    var o = e.split("."),
        a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r),
        s = o[1] ? i + o[1] : "";
    return a + s
  }
  "string" == typeof e && (e = e.replace(".", ""));
  var i = "",
    o = /\{\{\s*(\w+)\s*\}\}/,
    a = t || this.money_format;
  switch (a.match(o)[1]) {
    case "amount":
      i = r(e, 2);
      break;
    case "amount_no_decimals":
      i = r(e, 0);
      break;
    case "amount_with_comma_separator":
      i = r(e, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      i = r(e, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      i = r(e, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = r(e, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      i = r(e, 0, ".", "");
      break;
    case "amount_with_space_separator":
      i = r(e, 2, ",", "");
      break;
    case "amount_with_apostrophe_separator":
      i = r(e, 2, "'", ".")
  }
  return a.replace(o, i)
},
Shopify.KT_resizeImage = function(e, t) {
  try {
    if ("original" == t) return e;
    var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
    return n[1] + "_" + t + "." + n[2]
  } catch (r) {
    return e
  }
},
Shopify.KT_addItem = function(e, t, n) {
  var itemChange = e;
  var t = t || 1,
      r = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + t + "&id=" + e,
        dataType: "json",
        success: function(e) {
            "function" == typeof n ? n(itemChange,e,'undo') : Shopify.KT_onItemAdded(e)
        },
        error: function(e, t) {
            Shopify.KT_onError(e, t)
        }
      };
  jQuery.ajax(r)
},
Shopify.KT_addItemFromForm = function(e, t) {
  var el = e;
  var n = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery("#" + e).serialize(),
    dataType: "json",
    success: function(e) {
      // if ($("#"+el+' [name="quantity"][max]').length > 0) {
      //   var $this = $("#"+el+' [name="quantity"][max]');
      //   var max = parseInt($this.attr('max')), value = $this.val();
      //   max = max - value <= 0 ? 0 : max - value;
      //   $this.val(max == 0 ? 0 : 1).attr('max', max).trigger('change')
      // }
      if(jQuery("#"+el+" .itemGroupProducts").length > 0){
        Shopify.queue = [];
        $("#"+el+' .itemGroupProducts [name="quantity"]').each(function() {
          Shopify.queue.push({
            variantId: parseInt($(this).attr('data-id')),
            quantity: parseInt($(this).val(), 10) || 0
          });
        });        
        Shopify.KT_moveAlong();
      }else{
        "function" == typeof t ? t(e) : Shopify.KT_onItemAdded(e)
      }
    },
    error: function(e, t) {
      Shopify.KT_onError(e, t)
    }
  };
  jQuery.ajax(n)
},
Shopify.KT_addItemFromFormAddMore = function(el_id) {
  Shopify.queue = [];
  $(el_id+' [name="quantity"]').each(function() {
    Shopify.queue.push({
      variantId: parseInt($(this).attr('data-id')),
      quantity: parseInt($(this).val(), 10) || 0
    });
  });
  Shopify.KT_moveAlong();
},
Shopify.KT_moveAlong = function() {
  if (Shopify.queue.length) {
    var length = Shopify.queue.length;
    var request = Shopify.queue.shift();
    if (length == 1) {
      if (request.quantity > 0) {
        Shopify.KT_addItem(request.variantId, request.quantity);
      }else{        
        Shopify.KT_getCart();
      }
    } else {
      if (request.quantity > 0) {
        Shopify.KT_addItem(request.variantId, request.quantity, Shopify.KT_moveAlong);
      } else {
        Shopify.KT_moveAlong();
      }
    }
  }
};
Shopify.KT_getCart = function(e) {
  jQuery.getJSON("/cart.js", function(t, n) {
    "function" == typeof e ? e(t) : Shopify.KT_onCartUpdate(t)
  })
},
Shopify.KT_pollForCartShippingRatesForDestination = function(e, t, n) {
  n = n || Shopify.KT_onError;
  var r = {
    url: '/cart/async_shipping_rates',
    type: 'GET'
  }
  jQuery.ajax(r)
  .done(function(n, i, o) {
    // console.log("success");
    200 === o.status ? "function" == typeof t ? t(n.shipping_rates, e) : Shopify.KT_onCartShippingRatesUpdate(n.shipping_rates, e) : setTimeout(r, 500)
  })  
  .fail(function(XMLHttpRequest, textStatus) {
    // console.log("error");
    n(XMLHttpRequest, textStatus);
  });
},
Shopify.KT_getCartShippingRatesForDestination = function(e, t, n) {
  n = n || Shopify.KT_onError;
  // console.log(e);
  jQuery.ajax({
    url: '/cart/prepare_shipping_rates',
    type: 'POST',
    data: Shopify.KT_param({
      shipping_address: e
    })
  })
  .done(function() {
  // console.log("success");
    Shopify.KT_pollForCartShippingRatesForDestination(e, t, n);
  })
  .fail(function(XMLHttpRequest, textStatus) {
    // console.log("error");
    n(XMLHttpRequest, textStatus);
  });
},
Shopify.KT_getProduct = function(e, t) {
  jQuery.getJSON("/products/" + e + ".js", function(e, n) {
    "function" == typeof t ? t(e) : Shopify.KT_onProduct(e)
  })
},
Shopify.KT_changeItem = function(e, t, n) {
  var itemChange = e;
  var r = {
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + t + "&id=" + e,
      dataType: "json",
      success: function(e) {
        "function" == typeof n ? n(itemChange,e) : Shopify.KT_onCartUpdate(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(r)
},
Shopify.KT_removeItem = function(e, t) {
  var itemChange = e;
  var n = {
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&id=" + e,
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(itemChange,e,'remove item') : Shopify.KT_onCartUpdate(e,'remove item')
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_clear = function(e) {
  var t = {
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      success: function(t) {
        "function" == typeof e ? e(t) : Shopify.KT_onCartUpdate(t)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(t)
},
Shopify.KT_updateCartFromForm = function(e, t) {
  var n = {
      type: "POST",
      url: "/cart/update.js",
      data: jQuery("#" + e).serialize(),
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onCartUpdate(e);
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_updateCartAttributes = function(e, t) {
  var n = "";
  jQuery.isArray(e) ? jQuery.each(e, function(e, t) {
      var r = attributeToString(t.key);
      "" !== r && (n += "attributes[" + r + "]=" + attributeToString(t.value) + "&")
  }) : "object" == typeof e && null !== e && jQuery.each(e, function(e, t) {
      n += "attributes[" + attributeToString(e) + "]=" + attributeToString(t) + "&"
  });
  var r = {
      type: "POST",
      url: "/cart/update.js",
      data: n,
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onCartUpdate(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(r)
},
Shopify.KT_updateCartNote = function(e, t) {
  var n = {
      type: "POST",
      url: "/cart/update.js",
      data: "note=" + attributeToString(e),
      dataType: "json",
      success: function(e) {
        "function" == typeof t ? t(e) : Shopify.KT_onCartUpdate(e)
      },
      error: function(e, t) {
        Shopify.KT_onError(e, t)
      }
  };
  jQuery.ajax(n)
},
Shopify.KT_updatedCartNote = function(cart) {
  $('.note__cart-drawer .title').show();
  $('.note__cart-drawer .update').hide();
},
jQuery.fn.jquery >= "1.4" ? Shopify.KT_param = jQuery.param : (Shopify.KT_param = function(e) {
  var t = [],
    n = function(e, n) {
      n = jQuery.isFunction(n) ? n() : n, t[t.length] = encodeURIComponent(e) + "=" + encodeURIComponent(n)
    };
  if (jQuery.isArray(e) || e.jquery) jQuery.each(e, function() {
    n(this.name, this.value)
  });
  else
    for (var r in e) Shopify.KT_buildParams(r, e[r], n);
  return t.join("&").replace(/%20/g, "+")
},
Shopify.KT_buildParams = function(e, t, n) {
    jQuery.isArray(t) && t.length ? jQuery.each(t, function(t, r) {
      rbracket.test(e) ? n(e, r) : Shopify.KT_buildParams(e + "[" + ("object" == typeof r || jQuery.isArray(r) ? t : "") + "]", r, n)
    }) : null != t && "object" == typeof t ? Shopify.KT_isEmptyObject(t) ? n(e, "") : jQuery.each(t, function(t, r) {
      Shopify.KT_buildParams(e + "[" + t + "]", r, n)
    }) : n(e, t)
},
Shopify.KT_isEmptyObject = function(e) {
  for (var t in e) return !1;
  return !0
});

/* ----------- onCartUpdate customize for theme
---------------*/
Shopify.KT_onCartUpdate_ = function(cart,remove_action) {
  var table = $(".ajax__list-cart");
  var table_content = '';
  $('.cartCount').text(cart.item_count);
  $('.cartCost').attr('data-price',cart.total_price).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
  $('.title.has-item').html(cart.item_count == 1 ? theme.strings.cartItem.split('(')[0]+'('+cart.item_count+' item)'+theme.strings.cartItem.split(')')[1] : theme.strings.cartItems.split('(')[0]+'('+cart.item_count+' items)'+theme.strings.cartItems.split(')')[1]);
  $('.btn.loading').removeClass('loading');
  $('.btn.adding').text(theme.strings.addedToCart);

  anime({
    targets: '.cartCount:not(.fixed)',
    keyframes: [
      {translateY: '100%'},
      {translateY: 0}
    ],
    duration: 2000,
    easing: 'easeOutElastic(1, .8)',
    complete: function(anim) {
      $('.cartCount:not(.fixed)').removeAttr('style')
    }
  });

  // $.each(cart.items, function(index, val) {
  //   if (val.properties !== null && val.properties.limit !== undefined){
  //     var vrId = val.id;
  //     $.each('', function(index, val) {

  //     })
  //   }
  // });

  var iconCartVisible = function(){
    var cartVisible = false;
    $('.cartCount:not(.fixed)').each(function(el,idx){
      if(this.getBoundingClientRect().top > 1){
        cartVisible = true;
      }
      if((idx + 1) === $('.cartCount:not(.fixed)').length) {
        return false;
      }
    });
    return cartVisible;
  }
  if (theme.function.ajax_cart === 'drop' && iconCartVisible() === false) {
    $('body').addClass('popIn');
    anime({
      targets: '.cartCount.fixed',
      keyframes: [
        {backgroundColor: '#fff',color: '#555',scale: 1.25,rotate:-45,borderRadius:15},
        {backgroundColor: '#111',color: '#fff',scale: 1,rotate:0,borderRadius:50}
      ],
      duration: 2000,
      delay: 100,
      easing: 'easeOutElastic(1, .8)',
      complete: function(anim) {
        $('.cartCount.fixed').removeAttr('style')
      }
    });
  }
  var urlAjax = theme.function.ajax_cart == 'drawer' ? '/cart?view=listjson' : '/cart?view=listjsondrop';
  if($('.get__shipping').attr('data-curr-address') !== undefined && cart.item_count > 0){
    $('.get__shipping').show();
    var address = JSON.parse($('.get__shipping').attr('data-curr-address'));
    Shopify.KT_getCartShippingRatesForDestination(address,Shopify.Cart.getShippingCart,Shopify.Cart.onError);
  }
  $.ajax({
    type: 'get',
    url: urlAjax,
    beforeSend: function() {
      if(!remove_action && theme.function.ajax_cart == 'drawer'){
        theme.MenuReposive.is_mobile() ? $('.close-qs').trigger('touchstart') : $('.close-qs').trigger('click');
      }
      if (cart.item_count > 0) {
        if ( $( ".has-item" ).is( ":hidden" ) ) {
          $('.has-item').css({'display':''});
          $('.no-item').css({'display':'none'});
        }
      }
      else {
        if ( $( ".no-item" ).is( ":hidden" ) ) {
          $('.has-item').css({'display':'none'});
          $('.no-item').css({'display':''});
        }
      }
      if($('#myModal').length > 0){
        $('#myModal').modal('hide')
      }
    },
    success: function(table_content) {
      setTimeout(function(){
        $('.btn.adding').text(theme.strings.addToCart).removeClass('adding');
      },1000)
      table.html(table_content);
      if(!remove_action && theme.function.ajax_cart == 'drawer'){
        KT.drawOpen();
      }
      if($('.spendFreeShip').length > 0){
        var line_total = parseInt($('.spendFreeShip').find('[aria-valuemax]').attr('aria-valuemax'));
        var progress_bar = $('.spendFreeShip').find('.progress-bar');
        if (line_total > cart.total_price){
          progress_bar.attr('aria-valuenow', line_total - cart.total_price).css('width',cart.total_price / line_total * 100 + '%').text(Math.round(cart.total_price / line_total * 100) + '%');
          $('.spendFreeShip').find('.progress').removeClass('congratulations');
        }else{
          progress_bar.attr('aria-valuenow', line_total).css('width','100%').text('100%');
          $('.spendFreeShip').find('.progress').addClass('congratulations');
        }
      }
      $('.title-ajax__cart').html(cart.item_count == 1 ? theme.strings.cartItem.split('(')[0]+'('+cart.item_count+' item)'+theme.strings.cartItem.split(')')[1] : theme.strings.cartItems.split('(')[0]+'('+cart.item_count+' items)'+theme.strings.cartItems.split(')')[1]);
      if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
        Currency.convertAll(shopCurrency,cookieCurrency);
      }
      $('.content__cart-drawer.loading').removeClass('loading');
    }
  });
}


"undefined" == typeof Shopify.Cart && (Shopify.Cart = {});
Shopify.Cart.getShippingCart = function(respon,address) {
  $.ajax({
    type: "POST",
    url: '/cart.js',
    data: {"attributes[theme_shipping]": JSON.stringify(address)},
    dataType: 'json'
  });
  $('.get__shipping').attr('data-curr-address',JSON.stringify(address));
  if(respon.length == 0){
    $('.show__shipping').html('There are no shipping methods available for your cart or destination.');
  } else {
    var items_ = '';
    $.each(respon, function(index, val) {
      items_ += '<div class="item__shipping">';
      items_ += '<input id="item_spp'+index+'" type="radio" name="shipping-cart-drawer" data-name="'+val.code+'" value="'+val.price+'" placeholder=""';
      items_ += index == 0 ? 'checked="checked">' : '>';
      items_ += '<label class="content-item__shipping" for="item_spp'+index+'">';
      items_ += '<span class="name-item__shipping">'+val.name;
      if(val.delivery_days.length > 0){
        items_ += '</span><span class="delivery_days-item__shipping"> (';
        if(val.delivery_days.length >= 2){
          items_ += val.delivery_days[0]+'-'+val.delivery_days[1]+' days) . </span>';
        } else {
          items_ += val.delivery_days[0]+' day) . </span>';
        }
      } else {
        items_ += ' . </span>';
      }
      items_ += '<span class="price-item__shipping">'+theme.Currency.formatMoney(val.price * 100, theme.moneyFormat)+'</span>';
      items_ += '</label>';
      if(val.delivery_date !== null){
        items_ += '<div class="data-item__shipping"> Get by it ';
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var delivery_date  = new Date(val.delivery_date);
        items_ += delivery_date.toLocaleDateString("en-US", options);
        items_ += '</div>';
      }
      items_ += '</div>';
    });
    $('.show__shipping').html(items_);
    $('.get__shipping').show();
  }
  $('.show__shipping').css('opacity', '');
  $('.icon__shipping').removeClass('error');
  $('.svg-icon__shipping').removeClass('animated fadeInLeft infinite');
  $('.afterShip').show();
  var cartCost = parseFloat($('.cartCost').attr('data-price'));
  var shipp = parseFloat($('.show__shipping').find('input[type="radio"][checked="checked"]').val()) * 100;
  $('.show__shipping-price').html(theme.Currency.formatMoney(shipp, theme.moneyFormat));
  $('.cartCostPlusShipping').html(theme.Currency.formatMoney(cartCost+shipp, theme.moneyFormat));
  if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
    Currency.convertAll(shopCurrency,cookieCurrency);
  }
  KT.drawResize();
}
Shopify.Cart.fullMessagesFromErrors = function(e) {
  var t = [];
  return jQuery.each(e, function(e, r) {
    jQuery.each(r, function(r, n) {
      t.push(e + " " + n)
    })
  }), t
}
Shopify.Cart.onError = function(XMLHttpRequest, textStatus) {
  var feedback = "",
      data = eval("(" + XMLHttpRequest.responseText + ")");
  feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + Shopify.Cart.fullMessagesFromErrors(data).join("; ") + ".", "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination.");
  $('.show__shipping').html(feedback);
  $('.icon__shipping').addClass('error');
  $('.svg-icon__shipping').removeClass('animated fadeInLeft infinite');
}
Shopify.Cart.getCountry = function(){
  jQuery.ajax({
    url: '/cart?view=listcountry',
    type: 'GET',
    dataType: 'html',
    complete: function(xhr, textStatus) {
      //called when complete
    },
    success: function(data, textStatus, xhr) {
      //called when successful      
      $('#address_country').html(data);
      sessionStorage.dataCountry = data;
      Shopify.Cart.buildCountry(data)
    },
    error: function(xhr, textStatus, errorThrown) {
      //called when there is an error
    }
  });     
}
Shopify.Cart.buildCountry = function(data){
  if($('[name="address[country]"]').attr('data-default') !== undefined){
    $('[name="address[country]"]').val($('[name="address[country]"] option[value="'+$('[name="address[country]"]').attr('data-default')+'"]').val()).trigger('change');
  }
  var select = $('[name="address[country]"] option:selected').html(), provinces = $('[name="address[country]"] option:selected').attr('data-provinces');
  if (provinces !== "[]") {
    var provinces = JSON.parse($('[name="address[country]"] option:selected').attr('data-provinces'));
    var default_province = $('[name="address[province]"]').attr('data-default');
    var provinces_html = '';
    $.each(provinces, function(index, val) {
      if (default_province !== undefined && val[0] == default_province){
        $('[data-select="#address__province"]').html(val[1]);
        provinces_html += '<option selected="selected" value="'+val[0]+'">'+val[1]+'</option>';
      } else if (index == 0) {
        $('[data-select="#address__province"]').html(val[1]);
        provinces_html += '<option selected="selected" value="'+val[0]+'">'+val[1]+'</option>';
      }
      provinces_html += '<option value="'+val[0]+'">'+val[1]+'</option>';
    });
    $('[name="address[province]"]').html(provinces_html).parent().show();
    $('[name="address[zip]"]').val() == '1' ? $('[name="address[zip]"]').val('').parent().show() : $('[name="address[zip]"]').parent().show();
  } else {
    $('[name="address[province]"]').html('').parent().hide();
    $('[name="address[zip]"]').val(1).parent().hide();
  }
  if($('.get__shipping').attr('data-curr-address') !== undefined){
    var address = JSON.parse($('.get__shipping').attr('data-curr-address'));
    Shopify.KT_getCartShippingRatesForDestination(address,Shopify.Cart.getShippingCart,Shopify.Cart.onError);
  }
}
$(document)
.on('change','[name="address[country]"]',function(){
  $('.svg-icon__shipping').addClass('animated fadeInLeft');
  var select = $(this).find('option:selected').html(), provinces = $(this).find('option:selected').attr('data-provinces');
  $(this).parent().find('.label_hidden_select').html(select);
  if (provinces !== "[]") {
    var provinces = JSON.parse($(this).find('option:selected').attr('data-provinces'));
    var default_province = $('[name="address[province]"]').attr('data-default');
    var provinces_html = '';
    $.each(provinces, function(index, val) {
      if (default_province !== undefined && val[0] == default_province){
        $('[data-select="#address__province"]').html(val[1]);
        provinces_html += '<option selected="selected" value="'+val[0]+'">'+val[1]+'</option>';
      } else if (index == 0) {
        $('[data-select="#address__province"]').html(val[1]);
        provinces_html += '<option selected="selected" value="'+val[0]+'">'+val[1]+'</option>';
      }
      provinces_html += '<option value="'+val[0]+'">'+val[1]+'</option>';
    });
    $('[name="address[province]"]').html(provinces_html).parent().show();
    $('[name="address[zip]"]').val() == '1' ? $('[name="address[zip]"]').val('').parent().show() : $('[name="address[zip]"]').parent().show();
  } else {
    $('[name="address[province]"]').html('').parent().hide();
    $('[name="address[zip]"]').val(1).parent().hide();
  }
  KT.drawResize();
})
.on('change','[name="address[province]"]',function(){
  $('.svg-icon__shipping').addClass('animated fadeInLeft');
  var select = $(this).find('option:selected').html();
  $(this).parent().find('.label_hidden_select').html(select);       
  KT.drawResize();
})
.on('click','.icon__shipping',function(){
  var address = {
    'zip': $('[name="address[zip]"]').val(),
    'country': $('[name="address[country]"]').val(),
    'province': $('[name="address[province]"]').val() !== null ? $('[name="address[province]"]').val() : $('[name="address[country]"]').val()
  }
  if (JSON.stringify(address) !== $('.get__shipping').attr('data-curr-address')) {
    $('.show__shipping').css('opacity', '0.6');
    $(this).find('.svg-icon__shipping').addClass('animated fadeInLeft infinite');
    Shopify.KT_getCartShippingRatesForDestination(address,Shopify.Cart.getShippingCart,Shopify.Cart.onError);
  }
})
.on('change','[name="shipping-cart-drawer"]',function(){
  var cartCost = parseFloat($('.cartCost').attr('data-price'));
  var shipp = parseFloat($(this).val()) * 100;
  $('.show__shipping-price').html(theme.Currency.formatMoney(shipp, theme.moneyFormat));
  $('.cartCostPlusShipping').html(theme.Currency.formatMoney(cartCost+shipp, theme.moneyFormat));
  if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
    Currency.convertAll(shopCurrency,cookieCurrency);
  }
});
document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function(){    
    if ($('#address_country').length > 0) {
      if (typeof(Storage) !== "undefined" && sessionStorage.dataCountry !== undefined) {
        $('#address_country').html(sessionStorage.dataCountry);
        Shopify.Cart.buildCountry();
      } else {
        Shopify.Cart.getCountry();
      }
    }
  }, 5000)
});